module.exports = __webpack_public_path__ + "static/media/enemvip-logo.9800cc67.svg";